module.exports = __webpack_public_path__ + "spa-static/img/fb.266f89a1.svg";